import ReactDOM from "react-dom";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import ProjectDetailFood from "./pages/ProjectDetails/ProjectDetailFood";
import ProjectDetailBookio from "./pages/ProjectDetails/ProjectDetailBookio";
import ProjectDetailShopistry from "./pages/ProjectDetails/ProjectDetailShopistry";
import ProjectDetailHarvest from "./pages/ProjectDetails/ProjectDetailHarvest";
import ProjectDetailClimbingLight from "./pages/ProjectDetails/ProjectDetailClimbingLight";
import App from "./App";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import * as ROUTES from "./config/Routes";
import "./assets/styles/main.scss";

const AppBase = () => (
  <div className="app-container">
    <Header />
    <Switch>
      <Route
        exact
        path={ROUTES.PROJECT_DETAIL_FOODSHARER}
        render={() => <ProjectDetailFood />}
      />
      <Route
        exact
        path={ROUTES.PROJECT_DETAIL_BOOKIO}
        render={() => <ProjectDetailBookio />}
      />
      <Route
        exact
        path={ROUTES.PROJECT_DETAIL_SHOPISTRY}
        render={() => <ProjectDetailShopistry />}
      />
      <Route
        exact
        path={ROUTES.PROJECT_DETAIL_HARVEST}
        render={() => <ProjectDetailHarvest />}
      />
      <Route
        exact
        path={ROUTES.PROJECT_DETAIL_CLIMBING}
        render={() => <ProjectDetailClimbingLight />}
      />
      <Route exact path={ROUTES.HOME} render={() => <App />} />
    </Switch>
    <Footer />
  </div>
);

ReactDOM.render(
  <BrowserRouter>
    <AppBase />
  </BrowserRouter>,
  document.getElementById("root")
);
